import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function LandOwnerContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  handleViewPropDetails,
  landOwnerId,
  getSingleLandOwner,
  landOwnerInfo,
  getOwnerProperties,
  ownerProperties,
}) {
  useEffect(() => {
    if (_.isEmpty(landOwnerId)) return;
    getSingleLandOwner(landOwnerId);
    getOwnerProperties({ rptax_owner_id: landOwnerId });
  }, []);
  useEffect(() => {
    if (_.isEmpty(landOwnerId)) return;
    getSingleLandOwner(landOwnerId);
    getOwnerProperties({ rptax_owner_id: landOwnerId });
  }, [landOwnerId]);

  return (
    <div className="container-fluid card-section-content p-3">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-add font-weight-bold px-4 ml-auto"
          >
            Add&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>
      {!_.isEmpty(landOwnerInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-10">
                  <h3 className="">Information</h3>
                </div>
                <div className="col-2 d-flex">
                  <div className="ml-auto">
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(landOwnerInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleRemove(landOwnerInfo)}
                    >
                      <i className="far fa-trash-alt icon-delete" />
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <div className="mt-1">
                <div className="row d-flex justify-content-center">
                  <div className="col-12">
                    <div className="form-wrapper mb-3">
                      <div className="full-group border-bottom">
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">Name:</label>
                            <span className="full-input">
                              {_.get(landOwnerInfo, 'attributes.name') || ''}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">Region</label>
                            <span className="full-input">
                              {_.get(landOwnerInfo, 'attributes.region_name') ||
                                ''}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">Province</label>
                            <span className="full-input">
                              {_.get(
                                landOwnerInfo,
                                'attributes.province_name'
                              ) || ''}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">
                              Municipality
                            </label>
                            <span className="full-input">
                              {_.get(
                                landOwnerInfo,
                                'attributes.municipality_name'
                              ) || ''}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">Barangay</label>
                            <span className="full-input">
                              {_.get(
                                landOwnerInfo,
                                'attributes.barangay_name'
                              ) || ''}
                            </span>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="form-input-group col-12 border-right">
                            <label className="full-label mb-0">
                              Unit No. / House No. / Street Name
                            </label>
                            <span className="full-input">
                              {_.get(landOwnerInfo, 'attributes.street') || ''}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row d-flex justify-content-left w-100 border-top">
                    <div className="full-input font-weight-bold align-items-left col-6 mt-4">
                      Properties
                    </div>
                  </div>
                  <div className="row d-flex justify-content-center w-100">
                    <div className="col-12">
                      <table className="table table-striped">
                        <thead>
                          <tr className="cms-text-primary cms-bg-color-primary-light">
                            <th className="py-3" width={150}>
                              TDN
                            </th>
                            <th className="py-3">Property Location</th>
                            <th className="py-3" width={200}>
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {ownerProperties.length ? (
                            ownerProperties.map((e) => (
                              <tr key={e.id}>
                                <td className="align-middle text-dark p-2">
                                  {e.attributes.tdn}
                                </td>
                                <td className="align-middle text-dark p-2">
                                  {e.attributes.property_location || '-'}
                                </td>
                                <td className="p-2">
                                  <button
                                    type="button"
                                    className="btn btn-link mx-2 p-0"
                                    onClick={handleViewPropDetails(e)}
                                  >
                                    <i className="far fa-eye" /> View Details
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td>No Data</td>
                              <td />
                              <td />
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

LandOwnerContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,
  handleViewPropDetails: PropTypes.instanceOf(Function).isRequired,
  getSingleLandOwner: PropTypes.instanceOf(Function).isRequired,
  landOwnerInfo: PropTypes.instanceOf(Object).isRequired,
  getOwnerProperties: PropTypes.instanceOf(Function).isRequired,
  ownerProperties: PropTypes.instanceOf(Object).isRequired,
  landOwnerId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  landOwnerInfo: _.get(api, `${c.GET_SINGLE_LAND_OWNER}.item`) || {},
  ownerProperties: _.get(api, `${c.GET_OWNER_PROPERTIES}.list`) || {},
  landOwnerId: _.get(match, 'params.landOwnerId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LandOwnerContent);
